/*jslint browser */
/*global process */

var $ = jQuery;

/**
 *
 */
export default class Dump {
    /**
     *
     * @private
     */
    private _message: string;

    /**
     *
     */
    get message(): string {
        return this._message;
    }

    /**
     *
     * @param value
     */
    set message(value: string) {
        this._message = value;
    }
}